import { Permission } from "./userRoles";

export const isOrganizationalUnitSegmentationEnabled = (
  assignedPermissions?: readonly string[],
): boolean | undefined => assignedPermissions?.includes(Permission.debugApps);
